"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ImageEditDialogContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _get = _interopRequireDefault(require("lodash/get"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));
var _size = _interopRequireDefault(require("lodash/size"));
var _isMatch = _interopRequireDefault(require("lodash/isMatch"));
var _ComponentContainer = _interopRequireDefault(require("../../../../Framework/ComponentContainer"));
var _i18n = require("../../../../Framework/i18n");
var _ServiceLocator = require("../../../ServiceLocator");
var _Selectors = require("../../../Reducers/DesignArea/Selectors");
var _Selectors2 = require("../../../Reducers/DesignData/Selectors");
var _Selectors3 = require("../../../Reducers/ImageGallery/Selectors");
var _Selectors4 = require("../../../Reducers/UI/Selectors");
var _Actions = require("../../../Reducers/ImageGallery/Actions");
var _ImageEditDialog = _interopRequireDefault(require("../Components/ImageEditDialog"));
var _ImageUpload = _interopRequireDefault(require("../Components/ImageEditDialog/ImageUpload"));
var _ImageColorize = _interopRequireDefault(require("../Components/ImageColorize"));
var _FeedbackNotice = _interopRequireDefault(require("../Components/FeedbackNotice"));
var _Progress = _interopRequireDefault(require("../../../Shared/Components/Progress/Progress"));
var _DesignDataService = require("../../../Services/DesignDataService");
var _AddGalleryImage = _interopRequireDefault(require("./AddGalleryImage"));
var _createSelector = _interopRequireDefault(require("../../../../Utils/Function/createSelector"));
var _configuration = require("../../../configuration");
var _Constant = require("../../../Constant");
var _ImageEditUtils = require("../Utils/ImageEditUtils");
var _Transformers = require("../Utils/Transformers");
var _Selectors5 = require("../../../Reducers/Configurator/Selectors");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var getOperationsFromState = function getOperationsFromState(state) {
  var clipping = state.clipping,
    clippingColor = state.clippingColor,
    vectorize = state.vectorize,
    vectorizeThreshold = state.vectorizeThreshold,
    vectorizeColorsMap = state.vectorizeColorsMap;
  return {
    clipping: clipping,
    clippingColor: clippingColor,
    vectorize: vectorize,
    vectorizeThreshold: vectorizeThreshold,
    vectorizeColorsMap: vectorizeColorsMap
  };
};
var getLoadingState = (0, _Selectors4.createBackgroundWorkStateSelector)(_Actions.WN_UPLOAD_IMAGE);
var isVectorizableGalleryImage = function isVectorizableGalleryImage(imageData) {
  return Boolean(imageData && !(0, _get["default"])(imageData, 'operations.vectorize') && imageData.gallery && (0, _Selectors3.isEditableVectorImage)(imageData.preview));
};
var getDerivedOperationStateFromImageData = function getDerivedOperationStateFromImageData(imageData) {
  return {
    clipping: (0, _get["default"])(imageData, 'operations.clipping', null),
    clippingColor: (0, _get["default"])(imageData, 'operations.clippingColor', null),
    vectorize: !!(0, _get["default"])(imageData, 'operations.vectorize', false),
    vectorizeThreshold: (0, _get["default"])(imageData, 'operations.vectorizeThreshold', 0),
    vectorizeColorsMap: (0, _get["default"])(imageData, 'operations.vectorizeColorsMap', {}),
    vectorizeOriginalColorsMap: (0, _get["default"])(imageData, 'operations.vectorizeOriginalColorsMap', {}),
    vectorizeMaxColorAmount: (0, _get["default"])(imageData, 'operations.vectorizeMaxColorAmount', undefined)
  };
};
var isImageInvalidatedByChange = function isImageInvalidatedByChange(imageData1, imageData2) {
  return ['operations.clipping', 'operations.clippingColor', 'displayColorPreview'].some(function (key) {
    return (0, _get["default"])(imageData1, key, null) !== (0, _get["default"])(imageData2, key, null);
  });
};
var ImageEditDialogContainer = exports.ImageEditDialogContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(ImageEditDialogContainer, _React$Component);
  var _super = _createSuper(ImageEditDialogContainer);
  function ImageEditDialogContainer() {
    var _this;
    _classCallCheck(this, ImageEditDialogContainer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "colorAmountNoticeRef", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_assertThisInitialized(_this), "embroideryNoticeRef", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_assertThisInitialized(_this), "imageUploadRef", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_assertThisInitialized(_this), "state", {
      preview: null,
      clipping: null,
      clippingColor: null,
      vectorize: false,
      vectorizeThreshold: 0,
      vectorizeMaxColorAmount: undefined,
      vectorizeColorsMap: {},
      vectorizeOriginalColorsMap: {},
      activeTabIndex: 0,
      showAddImagePanel: false,
      colorAmount: 0,
      continueButtonDisabled: false,
      originalImagePreview: null,
      upload: null
    });
    _defineProperty(_assertThisInitialized(_this), "lastImageUpdateData", null);
    _defineProperty(_assertThisInitialized(_this), "updateOriginalPreview", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var image, previewUrl, isSvg, svgContent, preview;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            image = _this.props.image;
            previewUrl = "".concat((0, _configuration.getConf)('network.host')).concat(image.preview.url);
            isSvg = previewUrl && /\.svg$/.test(previewUrl);
            if (!isSvg) {
              _context.next = 11;
              break;
            }
            _context.next = 6;
            return (0, _DesignDataService.getSvgContent)(previewUrl, true);
          case 6:
            svgContent = _context.sent;
            preview = (0, _DesignDataService.applySvgContentOperations)(image.preview, null, svgContent);
            _this.setState({
              originalImagePreview: preview
            });
            _context.next = 12;
            break;
          case 11:
            _this.setState({
              originalImagePreview: previewUrl
            });
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_assertThisInitialized(_this), "setUpload", function (upload) {
      _this.setState({
        upload: upload
      });
    });
    _defineProperty(_assertThisInitialized(_this), "resetDerivedImageState", function () {
      _this.setState(_objectSpread({
        originalImagePreview: null
      }, getDerivedOperationStateFromImageData()));
    });
    _defineProperty(_assertThisInitialized(_this), "changeSelectedBackground", function (value) {
      var partialState = {
        clipping: value
      };
      if (value !== null && _this.state.clippingColor === null) {
        partialState.clippingColor = '#ffffff';
      }

      // remove the threshold value to trigger the re-creation of the color map
      if (_this.state.vectorizeThreshold) {
        partialState.vectorizeThreshold = null;
      }
      _this.handleStateChange(partialState);
    });
    _defineProperty(_assertThisInitialized(_this), "changeColor", function (color) {
      var partialState = {
        clippingColor: color.hex
      };
      if (_this.state.clipping === null) {
        partialState.clipping = 'replace';
      }

      // remove the threshold value to trigger the re-creation of the color map
      if (_this.state.vectorizeThreshold) {
        partialState.vectorizeThreshold = null;
      }
      _this.handleStateChange(partialState);
    });
    _defineProperty(_assertThisInitialized(_this), "handleStateChange", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(partialState) {
        var options,
          displayColorPreview,
          image,
          nextState,
          operations,
          result,
          vectorizeColorsMap,
          vectorizeThreshold,
          vectorizeMaxColorAmount,
          vectorizeOriginalColorsMap,
          _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
              displayColorPreview = options.displayColorPreview;
              image = _this.props.image;
              nextState = _objectSpread(_objectSpread({}, _this.state), partialState);
              _this.setState(nextState);
              operations = getOperationsFromState(nextState);
              if (!(!image || (0, _isMatch["default"])(image.operations, operations) && image.displayColorPreview === displayColorPreview)) {
                _context2.next = 8;
                break;
              }
              return _context2.abrupt("return");
            case 8:
              _this.continueBlocked = true;
              _context2.prev = 9;
              _context2.next = 12;
              return _this.props.editFile(operations, image, displayColorPreview !== undefined && {
                displayColorPreview: displayColorPreview
              });
            case 12:
              result = _context2.sent;
              vectorizeColorsMap = result.vectorizeColorsMap, vectorizeThreshold = result.vectorizeThreshold, vectorizeMaxColorAmount = result.vectorizeMaxColorAmount, vectorizeOriginalColorsMap = result.vectorizeOriginalColorsMap;
              _this.setState({
                vectorizeColorsMap: vectorizeColorsMap,
                vectorizeThreshold: vectorizeThreshold,
                vectorizeMaxColorAmount: vectorizeMaxColorAmount,
                vectorizeOriginalColorsMap: vectorizeOriginalColorsMap
              });
            case 15:
              _context2.prev = 15;
              _this.continueBlocked = false;
              return _context2.finish(15);
            case 18:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[9,, 15, 18]]);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "onVectorizeToggleChange", function (value) {
      _this.handleStateChange({
        vectorize: value
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onVectorizeThresholdChange", function (threshold) {
      var image = _this.props.image;

      // skip if the threshold is the same as the color count
      var colorCount = (0, _Selectors2.getAggregatedColorCount)(_this.state.vectorizeColorsMap);
      if (threshold === colorCount) {
        return;
      }
      if (threshold !== _this.state.vectorizeThreshold && !image.gallery) {
        return _this.handleStateChange({
          vectorizeThreshold: threshold
        });
      }

      // if the threshold value is the same, there might be some aggregated colors to restore
      return _this.handleStateChange(_objectSpread({
        vectorizeColorsMap: (0, _ImageEditUtils.expandVectorizeColorsMap)(_this.state.vectorizeColorsMap, _this.props.colorPalettes, threshold)
      }, image.gallery && {
        vectorizeThreshold: threshold
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "onColorImageStateReset", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _this.props.resetColorizing();
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })));
    _defineProperty(_assertThisInitialized(_this), "selectColor", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(colorKey, newColor) {
        var vectorizeColorsMap, colorKeys, _colorKey, _iterator, _step, _colorKey2;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              vectorizeColorsMap = (0, _cloneDeep["default"])(_this.state.vectorizeColorsMap);
              colorKeys = (0, _Selectors2.getColorKeysForAggregatedColor)(vectorizeColorsMap, colorKey);
              if (!_ServiceLocator.Services.designData.changeAllColorsNeeded()) {
                _context4.next = 13;
                break;
              }
              _context4.t0 = _regeneratorRuntime().keys(vectorizeColorsMap);
            case 4:
              if ((_context4.t1 = _context4.t0()).done) {
                _context4.next = 11;
                break;
              }
              _colorKey = _context4.t1.value;
              if (vectorizeColorsMap.hasOwnProperty(_colorKey)) {
                _context4.next = 8;
                break;
              }
              return _context4.abrupt("continue", 4);
            case 8:
              vectorizeColorsMap[_colorKey] = newColor;
              _context4.next = 4;
              break;
            case 11:
              _context4.next = 15;
              break;
            case 13:
              _iterator = _createForOfIteratorHelper(colorKeys);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  _colorKey2 = _step.value;
                  vectorizeColorsMap[_colorKey2] = _objectSpread(_objectSpread({}, newColor), {}, {
                    isUserColor: true
                  });
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            case 15:
              _context4.next = 17;
              return _this.handleStateChange({
                vectorizeColorsMap: vectorizeColorsMap
              });
            case 17:
              _ServiceLocator.Services.designData.setImageAndTextColor(newColor);
              _ServiceLocator.Services.analytics.triggerEvent(_Constant.EventTypes.image_edit_colorize_color, newColor.value.replace('#', ''));
            case 19:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function (_x2, _x3) {
        return _ref4.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "removeColor", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(colorKey) {
        var vectorizeColorsMap, closestColor;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              vectorizeColorsMap = _this.state.vectorizeColorsMap;
              if (vectorizeColorsMap[colorKey]) {
                _context5.next = 3;
                break;
              }
              throw new Error('Color key does not exist!');
            case 3:
              closestColor = (0, _ImageEditUtils.getClosestColorFromMap)(vectorizeColorsMap, vectorizeColorsMap[colorKey].value);
              _context5.next = 6;
              return _this.selectColor(colorKey, closestColor);
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function (_x4) {
        return _ref5.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "onActiveTabChange", function (activeTabIndex) {
      var image = _this.props.image;
      var upload = _this.state.upload;
      if (upload !== null) {
        return;
      }
      if (!image && [1, 2].indexOf(activeTabIndex) !== -1) {
        return;
      }
      _this.setState({
        activeTabIndex: activeTabIndex
      });
    });
    _defineProperty(_assertThisInitialized(_this), "updatePreview", /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(svgContent) {
        var _image$preview;
        var options,
          _options$forceFetch,
          forceFetch,
          image,
          activeTabIndex,
          preview,
          originalImagePreview,
          previewUrl,
          isSvg,
          updateSVG,
          forceUpdate,
          _args6 = arguments;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              options = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {};
              _options$forceFetch = options.forceFetch, forceFetch = _options$forceFetch === void 0 ? false : _options$forceFetch;
              image = _this.props.image;
              activeTabIndex = _this.state.activeTabIndex;
              preview = null;
              originalImagePreview = null;
              previewUrl = image === null || image === void 0 || (_image$preview = image.preview) === null || _image$preview === void 0 ? void 0 : _image$preview.url;
              if (previewUrl && activeTabIndex === 1) {
                previewUrl = (0, _Transformers.getRasterURL)(previewUrl);
              }
              isSvg = previewUrl && /\.svg$/.test(previewUrl);
              if (!image) {
                _context6.next = 22;
                break;
              }
              updateSVG = isSvg;
              if (!updateSVG) {
                _context6.next = 19;
                break;
              }
              if (svgContent) {
                _context6.next = 16;
                break;
              }
              _context6.next = 15;
              return (0, _DesignDataService.getSvgContent)(image.preview.url, false, forceFetch);
            case 15:
              svgContent = _context6.sent;
            case 16:
              preview = (0, _DesignDataService.applySvgContentOperations)(image.preview, image.displayColorPreview ? image.operations : null, svgContent);
              _context6.next = 22;
              break;
            case 19:
              forceUpdate = isImageInvalidatedByChange(_this.lastImageUpdateData, image);
              if (forceUpdate) {
                _this.previewVersion = Math.random();
              }
              if (previewUrl) {
                preview = (0, _Selectors3.getPreviewUrlFromImageData)(previewUrl) + (_this.previewVersion ? "?".concat(_this.previewVersion) : '');
                originalImagePreview = preview;
              }
            case 22:
              _this.lastImageUpdateData = image;
              _this.setState({
                preview: preview,
                originalImagePreview: originalImagePreview
              });
            case 24:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      return function (_x5) {
        return _ref6.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "closeAddImagePanel", function () {
      return _this.setState({
        showAddImagePanel: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onSelectImage", /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(file) {
        var addGalleryImageToUserImages, imageUrl, thumbUrl, fileName, vectorizeColorsMap;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              addGalleryImageToUserImages = _this.props.addGalleryImageToUserImages;
              imageUrl = file.imageUrl, thumbUrl = file.thumbUrl;
              fileName = imageUrl.replace(/^.*[\\/]/, '') // get filename
              .replace(/\.[^.$]+$/, ''); // remove extension
              _context7.next = 5;
              return _ServiceLocator.Services.designData.getGalleryImageColors(imageUrl);
            case 5:
              vectorizeColorsMap = _context7.sent;
              addGalleryImageToUserImages(imageUrl, thumbUrl, fileName, vectorizeColorsMap);

              // exit image upload if a gallery image is selected
              _this.setUpload(null);
            case 8:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      return function (_x6) {
        return _ref7.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "continueClick", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
      var _this$props, colorDisabled, image, shouldAddImageImmediately, colorPreviewRequirementFulfilled, _this$state, activeTabIndex, continueButtonDisabled;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            if (!_this.continueBlocked) {
              _context8.next = 2;
              break;
            }
            return _context8.abrupt("return");
          case 2:
            _this$props = _this.props, colorDisabled = _this$props.colorDisabled, image = _this$props.image, shouldAddImageImmediately = _this$props.shouldAddImageImmediately, colorPreviewRequirementFulfilled = _this$props.colorPreviewRequirementFulfilled;
            _this$state = _this.state, activeTabIndex = _this$state.activeTabIndex, continueButtonDisabled = _this$state.continueButtonDisabled;
            if (!(activeTabIndex === 0 && shouldAddImageImmediately(image))) {
              _context8.next = 13;
              break;
            }
            _this.continueBlocked = true;
            _context8.prev = 6;
            _context8.next = 9;
            return _ServiceLocator.Services.designer.imageEditDialogContinueClickHandler();
          case 9:
            _context8.prev = 9;
            _this.continueBlocked = false;
            return _context8.finish(9);
          case 12:
            return _context8.abrupt("return");
          case 13:
            if (!(activeTabIndex === 0 && !(image.gallery && colorDisabled))) {
              _context8.next = 16;
              break;
            }
            _this.setState({
              activeTabIndex: image.gallery ? 2 : 1
            });
            return _context8.abrupt("return");
          case 16:
            if (!(activeTabIndex === 1 && !colorDisabled)) {
              _context8.next = 19;
              break;
            }
            _this.setState({
              activeTabIndex: 2
            });
            return _context8.abrupt("return");
          case 19:
            if (!(activeTabIndex === 2 && !colorPreviewRequirementFulfilled)) {
              _context8.next = 23;
              break;
            }
            if (!(_this.embroideryNoticeRef && _this.embroideryNoticeRef.current)) {
              _context8.next = 23;
              break;
            }
            _this.embroideryNoticeRef.current.scrollIntoView();
            return _context8.abrupt("return");
          case 23:
            if (!continueButtonDisabled) {
              _context8.next = 27;
              break;
            }
            if (!(_this.colorAmountNoticeRef && _this.colorAmountNoticeRef.current)) {
              _context8.next = 27;
              break;
            }
            _this.colorAmountNoticeRef.current.scrollIntoView();
            return _context8.abrupt("return");
          case 27:
            _this.continueBlocked = true;
            _context8.prev = 28;
            _context8.next = 31;
            return _ServiceLocator.Services.designer.imageEditDialogContinueClickHandler();
          case 31:
            _context8.prev = 31;
            _this.continueBlocked = false;
            return _context8.finish(31);
          case 34:
          case "end":
            return _context8.stop();
        }
      }, _callee8, null, [[6,, 9, 12], [28,, 31, 34]]);
    })));
    _defineProperty(_assertThisInitialized(_this), "onGalleryClick", function () {
      _this.setState({
        showAddImagePanel: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "closePreviewDialog", function () {
      _ServiceLocator.Services.designer.imageEditDialogCloseHandler();
    });
    _defineProperty(_assertThisInitialized(_this), "onOriginalImageAndColorPreviewToggleClick", function () {
      _this.handleStateChange({}, {
        displayColorPreview: !_this.props.displayColorPreview
      });
    });
    _defineProperty(_assertThisInitialized(_this), "uploadImage", function () {
      return _this.imageUploadRef.current.uploadFile();
    });
    _defineProperty(_assertThisInitialized(_this), "onNewUploadClick", function () {
      _this.setUpload({
        disabled: true
      });
      _this.resetDerivedImageState();
    });
    _defineProperty(_assertThisInitialized(_this), "selectUserImage", function (imageIndex) {
      var _this$props2 = _this.props,
        userImages = _this$props2.userImages,
        setSelectedImage = _this$props2.setSelectedImage;
      setSelectedImage(userImages[imageIndex].identifier);
      _this.resetDerivedImageState();
    });
    return _this;
  }
  _createClass(ImageEditDialogContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updatePreview(null);
      var _this$props3 = this.props,
        image = _this$props3.image,
        editMode = _this$props3.editMode,
        hasPlaceHolderImage = _this$props3.hasPlaceHolderImage,
        colorDisabled = _this$props3.colorDisabled;
      var initialState = getDerivedOperationStateFromImageData(image);
      if (editMode && image && !hasPlaceHolderImage) {
        initialState.activeTabIndex = initialState.vectorize && !colorDisabled ? 2 : 1;
      }
      this.setState(initialState);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props4 = this.props,
        image = _this$props4.image,
        open = _this$props4.open,
        maxColorAmount = _this$props4.maxColorAmount,
        editMode = _this$props4.editMode,
        hasPlaceHolderImage = _this$props4.hasPlaceHolderImage,
        isImageCompatible = _this$props4.isImageCompatible,
        isColorMappingCompatible = _this$props4.isColorMappingCompatible,
        vectorsRequired = _this$props4.vectorsRequired,
        vectorizedLogoMandatory = _this$props4.vectorizedLogoMandatory;
      var _this$state2 = this.state,
        vectorize = _this$state2.vectorize,
        vectorizeColorsMap = _this$state2.vectorizeColorsMap,
        activeTabIndex = _this$state2.activeTabIndex,
        originalImagePreview = _this$state2.originalImagePreview;
      var newState = {};
      var justOpened = open !== prevProps.open && open;
      var imageChanged = !!image && image !== prevProps.image;
      var prevOperationData = getDerivedOperationStateFromImageData(prevProps.image);
      var operationData = getDerivedOperationStateFromImageData(image);
      var operationsChanged = !!image && !(0, _isEqual["default"])(prevOperationData, operationData);
      if (image && image.preview && image.preview.url && activeTabIndex === 2 && originalImagePreview === null && !(0, _Transformers.isOriginalVector)(image)) {
        this.updateOriginalPreview();
      }
      if (operationsChanged) {
        Object.assign(newState, operationData);
      }
      if (justOpened) {
        var _activeTabIndex = 0;
        if (image && editMode && !hasPlaceHolderImage) {
          _activeTabIndex = (0, _Selectors3.isEditableVectorImage)(image.preview) ? 2 : 1;
        }
        Object.assign(newState, {
          activeTabIndex: _activeTabIndex
        });
      }
      if (maxColorAmount !== prevProps.maxColorAmount || vectorize !== prevState.vectorize || vectorizeColorsMap !== prevState.vectorizeColorsMap || activeTabIndex !== prevState.activeTabIndex) {
        var colorAmount = (0, _Selectors2.getAggregatedColorCount)(vectorizeColorsMap);
        var continueButtonDisabled = activeTabIndex === 2 && vectorize && !!maxColorAmount && colorAmount > maxColorAmount;
        this.setState({
          colorAmount: colorAmount,
          continueButtonDisabled: continueButtonDisabled
        });
      }
      if (activeTabIndex === 2 && isVectorizableGalleryImage(image) && (!vectorize ||
      // if the user comes from the background removal tab vectorizing should be performed again
      prevState.activeTabIndex === 1)) {
        Object.assign(newState, {
          vectorize: true
        });
      }

      // when switching to the colorizing tab the color has to be made compatible
      if (activeTabIndex === 2 && activeTabIndex !== prevState.activeTabIndex && (!isImageCompatible(image) || !isColorMappingCompatible(vectorizeColorsMap))) {
        Object.assign(newState, {
          vectorizeColorsMap: vectorizeColorsMap
        });
      }
      if (activeTabIndex === 2 && (vectorsRequired || vectorizedLogoMandatory) && !vectorize && !image.gallery) {
        Object.assign(newState, {
          vectorize: true
        });
      }
      var options;
      if (activeTabIndex === 2 && !image.gallery && vectorizedLogoMandatory && !image.displayColorPreview && !this.state.displayColorPreview) {
        options = {
          displayColorPreview: true
        };
        Object.assign(newState, {
          displayColorPreview: true
        });
      }
      (!(0, _isMatch["default"])(this.state, newState) || options) && this.handleStateChange(newState, options);
      if ((justOpened || imageChanged) && !image.incomplete) {
        this.updatePreview(null, {
          forceFetch: operationsChanged
        });
      } else if (activeTabIndex !== prevState.activeTabIndex && vectorize) {
        this.updatePreview(null, {
          forceFetch: true
        });
      }

      // update upload state if it is just opened
      if (justOpened) {
        var _this$props5 = this.props,
          userImages = _this$props5.userImages,
          galleryHasImages = _this$props5.galleryHasImages;
        var upload = null;

        // if no gallery images, default to user upload
        if (!image && !userImages.length && !galleryHasImages) {
          upload = {
            disabled: true
          };
        }
        this.setUpload(upload);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props6 = this.props,
        loading = _this$props6.loading,
        ProgressComponent = _this$props6.ProgressComponent,
        errorCode = _this$props6.errorCode,
        colorPalettes = _this$props6.colorPalettes,
        maxColorAmount = _this$props6.maxColorAmount,
        colorDisabled = _this$props6.colorDisabled,
        vectorsRequired = _this$props6.vectorsRequired,
        vectorizedLogoMandatory = _this$props6.vectorizedLogoMandatory,
        image = _this$props6.image,
        usedColors = _this$props6.usedColors,
        imageColorsWereEdited = _this$props6.imageColorsWereEdited,
        colorPreviewEnabled = _this$props6.colorPreviewEnabled,
        colorPreviewRequirementFulfilled = _this$props6.colorPreviewRequirementFulfilled,
        uploadSize = _this$props6.uploadSize,
        ImageColorizeComponent = _this$props6.ImageColorizeComponent,
        ImageUploadComponent = _this$props6.ImageUploadComponent,
        customControlElements = _this$props6.customControlElements,
        checkOwnership = _this$props6.checkOwnership,
        designProductionMethod = _this$props6.designProductionMethod,
        client = _this$props6.client;
      var _this$state3 = this.state,
        preview = _this$state3.preview,
        clipping = _this$state3.clipping,
        vectorize = _this$state3.vectorize,
        vectorizeColorsMap = _this$state3.vectorizeColorsMap,
        activeTabIndex = _this$state3.activeTabIndex,
        colorAmount = _this$state3.colorAmount,
        continueButtonDisabled = _this$state3.continueButtonDisabled,
        originalImagePreview = _this$state3.originalImagePreview,
        upload = _this$state3.upload;
      var isGalleryImage = image && !!image.gallery;
      var showWarningMessage = (0, _Selectors3.showVectorizeImageQuality)(image);
      var aggregatedColors = (0, _Selectors2.getAggregatedColors)(vectorizeColorsMap);
      var colorAmountList = Array(maxColorAmount).fill(null).map(function (_, i) {
        return i + 1;
      });
      var colorCount = (0, _size["default"])(aggregatedColors);
      var colorPreviewBlockActive = activeTabIndex === 2 && colorCount > 0 && !isGalleryImage && !vectorizedLogoMandatory && (colorPreviewEnabled || !colorPreviewRequirementFulfilled);
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_ImageEditDialog["default"], _extends({}, this.props, {
        loaderComponent: /*#__PURE__*/_react["default"].createElement(ProgressComponent, {
          loading: loading
        }),
        errorFeedback: errorCode && /*#__PURE__*/_react["default"].createElement(_FeedbackNotice["default"], {
          errorNotice: (0, _i18n.t)("fileUpload.errors.".concat(errorCode))
        }),
        changeSelectedBackground: this.changeSelectedBackground,
        onChangeColor: this.changeColor,
        closePreviewDialog: this.closePreviewDialog,
        backgroundSelected: clipping,
        preview: preview,
        colorPickerEnabled: !!clipping,
        continueButtonDisabled: continueButtonDisabled,
        continueClick: this.continueClick,
        showWarningMessage: showWarningMessage,
        imageColorizeElement: /*#__PURE__*/_react["default"].createElement(ImageColorizeComponent, {
          inputRef: this.colorAmountNoticeRef,
          colorPalettes: colorPalettes,
          usedColors: usedColors,
          vectorizeThreshold: colorCount > maxColorAmount ? 0 : colorCount,
          onVectorizeThresholdChange: this.onVectorizeThresholdChange,
          vectorizeColorsMap: vectorizeColorsMap,
          onColorSelectClick: this.selectColor,
          onColorRemoveClick: this.removeColor,
          aggregatedColors: aggregatedColors,
          disableInputs: !vectorize && !isGalleryImage || colorDisabled,
          maxColorAmount: maxColorAmount,
          colorAmount: colorAmount,
          vectorize: vectorize,
          onVectorizeToggleChange: this.onVectorizeToggleChange,
          vectorizeToggleDisabled: vectorsRequired || isGalleryImage && vectorize,
          onColorImageStateReset: this.onColorImageStateReset,
          isLoading: loading,
          imageColorsWereEdited: imageColorsWereEdited,
          vectorsRequired: vectorsRequired,
          colorAmountList: colorAmountList,
          customControlElements: customControlElements,
          designProductionMethodName: designProductionMethod === null || designProductionMethod === void 0 ? void 0 : designProductionMethod.title
        }),
        activeTabIndex: activeTabIndex,
        onActiveTabChange: this.onActiveTabChange,
        onGalleryClick: this.onGalleryClick,
        onOriginalImageAndColorPreviewToggleClick: this.onOriginalImageAndColorPreviewToggleClick,
        originalImagePreview: originalImagePreview,
        embroideryNoticeRef: this.embroideryNoticeRef,
        colorPreviewBlockActive: colorPreviewBlockActive,
        onNewUploadClick: this.onNewUploadClick,
        showUploadPanel: upload !== null,
        uploadDisabled: !!(upload && upload.disabled),
        uploadImage: this.uploadImage,
        selectUserImage: this.selectUserImage,
        imageUploadElement: /*#__PURE__*/_react["default"].createElement(ImageUploadComponent, {
          innerRef: this.imageUploadRef,
          uploadSize: uploadSize,
          onValidate: function onValidate(_ref9) {
            var isValid = _ref9.isValid;
            return _this2.setUpload({
              disabled: !isValid
            });
          },
          onUploadFinished: function onUploadFinished() {
            _this2.setUpload(null);
            _this2.onActiveTabChange(1);
          },
          checkOwnership: checkOwnership
        })
      })), /*#__PURE__*/_react["default"].createElement(_AddGalleryImage["default"], {
        open: this.state.showAddImagePanel,
        onClose: this.closeAddImagePanel,
        onSelectImage: this.onSelectImage,
        client: client
      }));
    }
  }]);
  return ImageEditDialogContainer;
}(_react["default"].Component);
_defineProperty(ImageEditDialogContainer, "defaultProps", {
  colorPreviewRequirementFulfilled: false,
  colorPreviewEnabled: false,
  checkOwnership: true
});
var getUserImages = (0, _createSelector["default"])(function (imageGalleryState) {
  return imageGalleryState.userImages;
}, function (images) {
  var host = (0, _configuration.getConf)('network.host');
  var userImages = images.filter(function (image) {
    return !image.isPlaceHolderImage;
  });
  return userImages.map(function (image) {
    return _objectSpread(_objectSpread({}, image), {}, {
      url: "".concat(host).concat(image.thumbnail.url)
    });
  });
});
var mapStateToProps = function mapStateToProps(state) {
  var ui = state.ui,
    imageGallery = state.imageGallery;
  var colorPalettes = (0, _Selectors.getColorPalettes)(state);
  var designProductionMethod = (0, _Selectors.getSelectedDesignProductionMethod)(state);
  var vectorsRequired = !!(0, _get["default"])(designProductionMethod, 'options.vectorsRequired');
  var vectorizedLogoMandatory = !!(0, _get["default"])(designProductionMethod, 'options.vectorizedLogoMandatory');
  var colorDisabled = (0, _Selectors.isColoringDisabled)(state);
  var userImages = getUserImages(imageGallery);
  var hasPlaceHolderImage = (0, _Selectors.hasPlaceHolderImagesForActiveDesignArea)(state);
  var firstUserImageToPreSelect = userImages.length > 0 ? userImages[0] : null;
  var userImage = imageGallery.selectedImage || firstUserImageToPreSelect;
  var defaultMaxColorAmount = (0, _configuration.getConf)('designer.maxColorAmount', 10);
  var maxColorAmount = Math.min(+(0, _get["default"])(designProductionMethod, 'options.maxColorAmount') || defaultMaxColorAmount, +(0, _get["default"])(userImage, 'operations.vectorizeMaxColorAmount', defaultMaxColorAmount));
  var editMode = (0, _Selectors3.isEditMode)(state);
  var galleryHasImages = imageGallery.gallery.length !== 0;
  var uploadSize = (0, _Selectors.getMaxUploadSize)(state);
  var open = !!ui.visibilityMap.imageEditDialog;
  var usedColors = (0, _Selectors.getDesignDataUsedColors)(state);
  var displayColorPreview = userImage && !!userImage.displayColorPreview;
  var colorPreviewEnabled = userImage && !!userImage.colorPreviewEnabled;
  var imageColorsWereEdited = userImage && !!userImage.imageColorsWereEdited;
  var initialColorMaxAmount = (0, _Selectors2.getInitialMaxColorAmount)(state);
  var colorPreviewRequirementFulfilled = (0, _Selectors3.isColorPreviewCompatible)(state, userImage);
  var client = (0, _Selectors5.getClient)((0, _Selectors5.getConfigurator)(state));
  return {
    Component: open ? ImageEditDialogContainer : function () {
      return null;
    },
    ProgressComponent: _Progress["default"],
    ImageColorizeComponent: _ImageColorize["default"],
    ImageUploadComponent: _ImageUpload["default"],
    errorCode: imageGallery.lastErrorCode,
    loading: getLoadingState(ui) || !!(userImage && userImage.incomplete),
    image: userImage,
    maxColorAmount: maxColorAmount,
    displayColorPreview: displayColorPreview,
    colorPreviewEnabled: colorPreviewEnabled,
    imageColorsWereEdited: imageColorsWereEdited,
    editMode: editMode,
    open: open,
    userImages: userImages,
    colorPalettes: colorPalettes,
    vectorsRequired: vectorsRequired,
    vectorizedLogoMandatory: vectorizedLogoMandatory,
    colorDisabled: colorDisabled,
    uploadSize: uploadSize,
    galleryHasImages: galleryHasImages,
    usedColors: usedColors,
    hasPlaceHolderImage: hasPlaceHolderImage,
    initialColorMaxAmount: initialColorMaxAmount,
    colorPreviewRequirementFulfilled: colorPreviewRequirementFulfilled,
    designProductionMethod: designProductionMethod,
    client: client
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    editFile: function editFile(operations, image) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return _ServiceLocator.Services.designData.editFileQueued(operations, image, _objectSpread({
        addMode: (0, _Selectors3.isAddMode)(_ServiceLocator.Services.store.state)
      }, options));
    },
    setSelectedImage: function setSelectedImage(identifier) {
      return dispatch((0, _Actions.setSelectedImageByIdentifier)(identifier));
    },
    addGalleryImageToUserImages: function addGalleryImageToUserImages(imageUrl, thumbUrl, fileName, vectorizeColorsMap) {
      return dispatch((0, _Actions.addGalleryImageToUserImages)(imageUrl, thumbUrl, fileName, vectorizeColorsMap));
    },
    shouldAddImageImmediately: function shouldAddImageImmediately(imageData) {
      return (0, _Selectors3.isImageReadyToBeAdded)(_ServiceLocator.Services.store.state, imageData);
    },
    isColorMappingCompatible: function isColorMappingCompatible(vectorizeColorsMap) {
      return (0, _Selectors3.isColorMappingCompatible)((0, _Selectors.getSelectedDesignProductionMethod)(_ServiceLocator.Services.store.state).colorPalettes, vectorizeColorsMap);
    },
    isImageCompatible: function isImageCompatible(imageData) {
      return (0, _Selectors3.isImageCompatible)(_ServiceLocator.Services.store.state, imageData);
    },
    resetColorizing: function resetColorizing() {
      return _ServiceLocator.Services.designData.resetEditedFile();
    }
  };
};
var _default = exports["default"] = (0, _ComponentContainer["default"])(mapStateToProps, mapDispatchToProps);